class CartControls {
  constructor() {
    if (CartControls.instance) {
      return CartControls.instance;
    }

    CartControls.instance = this;

    this.providerId = "695e2a988b39380babbc1af2";
    this.domain = "https://api.unicheck.app/api/v1/delivery/novaPost";

    this.deliveryCity = "";
    this.currentInputId = null;

    this.defaultLanguage = "uk";
    this.language = window?.Shopify?.locale || this.defaultLanguage;
    this.defineTranslations();

    this.isHovered = false;
    this.isOriginalText = true;

    this.addControlButtons();
  }

  addControlButtons() {
    const inited = this.init();
    if (!inited) return;

    this.removeEventHandlers();
    this.bindEventHandlers();
  }


  bindEventHandlers() {
    this.changeHandlerBound = this.changeHandler.bind(this);
    this.toggleOverlayBound = this.toggleOverlay.bind(this);
    this.controlButtonClickHandlerBound =
      this.controlButtonClickHandler.bind(this);
    this.inputHandlerBound = this.inputHandler.bind(this);
    this.documentClickHandlerBound = this.documentClickHandler.bind(this);
    this.mouseoverHandlerBound = this.mouseoverHandler.bind(this);
    this.mouseoutHandlerBound = this.mouseoutHandler.bind(this);
    this.submitHandlerBound = this.submitHandler.bind(this);

    this.deliveryTypeRadios.forEach((radio) => {
      radio.addEventListener("change", this.changeHandlerBound);
    });

    this.overlayCloseBtn.addEventListener("click", this.toggleOverlayBound);

    this.controlButtons?.addEventListener(
      "click",
      this.controlButtonClickHandlerBound
    );

    this.inputs.forEach((input) => {
      input.addEventListener("input", this.inputHandlerBound);
    });

    document.addEventListener("click", this.documentClickHandlerBound);

    this.submitButton?.addEventListener(
      "mouseover",
      this.mouseoverHandlerBound
    );
    this.submitButton?.addEventListener("mouseout", this.mouseoutHandlerBound);

    this.submitButton?.addEventListener("click", this.submitHandlerBound);
  }

  removeEventHandlers() {
    this.deliveryTypeRadios.forEach((radio) => {
      radio.removeEventListener("change", this.changeHandlerBound);
    });

    this.overlayCloseBtn.removeEventListener("click", this.toggleOverlayBound);

    this.controlButtons?.removeEventListener(
      "click",
      this.controlButtonClickHandlerBound
    );

    this.inputs.forEach((input) => {
      input.removeEventListener("input", this.inputHandlerBound);
    });

    document.removeEventListener("click", this.documentClickHandlerBound);

    this.submitButton?.removeEventListener(
      "mouseover",
      this.mouseoverHandlerBound
    );
    this.submitButton?.removeEventListener(
      "mouseout",
      this.mouseoutHandlerBound
    );

    this.submitButton?.removeEventListener("click", this.submitHandlerBound);
  }

  init() {
    this.isCartDrawer = document.querySelector(".cart-drawer__inner");
    this.isCartPage = document.querySelector(".cart-page");

    if (this.isCartDrawer) {
      document.body.classList.add("is-cart-drawer");
      this.cart = this.isCartDrawer;

      this.cartSummary = this.cart.querySelector(".cart-drawer__summary");

      if (!this.cartSummary) {
        return false;
      }

      this.cartSummary.style.webkitMaskImage = "none";
      this.cartSummary.style.maskImage = "none";
      this.cart.querySelector(".cart-drawer__content").style.overflow =
        "hidden";

    } else if (this.isCartPage) {
      document.body.classList.add("is-cart-page");
      this.cart = this.isCartPage;
    } else {
      return false;
    }

    this.cartFooter = this.cart.querySelector(".cart__ctas");

    this.controlButtons = this.cart.querySelector(".cart-controls__buttons");
    this.overlay = this.cart.querySelector(".cart-controls__overlay");
    this.overlayCloseBtn = this.cart.querySelector(
      ".controls-overlay__close-button"
    );
    this.suggestionsLists = this.cart.querySelectorAll(
      ".overlay-form__suggestions"
    );
    this.deliveryTypeRadios = this.cart.querySelectorAll(
      ".overlay-form__radio-input"
    );
    this.inputs = this.cart.querySelectorAll(".overlay-form__input");

    this.submitButton = this.cartFooter.querySelector('button[type="submit"]');
    this.originalSubmitButtonText = this.submitButton.innerHTML;
    this.submitButton.style.minHeight = this.submitButton.offsetHeight + "px";

    const { deliveryType } = this.getDeliveryInfo();
    this.checkDeliveryType(deliveryType);

    return true;
  }

  toggleOverlay() {
    const isActive = this.overlay.classList.toggle("active");

    if (this.isCartDrawer) {
      const ctaContainer = this.cart.querySelector('.cart__ctas');
      const rootContainer = this.cart.querySelector('cart-items-component');
      const summary = this.cart.querySelector('.cart-drawer__summary');

      const isMobile = window.innerWidth < 750;
      const paddingValue = isMobile ? "1rem" : "1.5rem";

      if (isActive) {
        rootContainer.appendChild(ctaContainer);

        ctaContainer.style.position = "relative";
        ctaContainer.style.zIndex = "100";
        ctaContainer.style.padding = paddingValue;
        ctaContainer.style.background = "transparent";

        const agreement = this.cart.querySelector('.cart__agreement-wrapper');
        if (agreement) {
          agreement.style.position = "relative";
          agreement.style.zIndex = "100";
        }

        const ctaHeight = ctaContainer.offsetHeight;
        this.overlay.style.paddingBottom = `${ctaHeight - 16}px`;
      } else {
        if (summary) {
          summary.appendChild(ctaContainer);
        }
        
        ctaContainer.style.padding = "0";
        ctaContainer.style.zIndex = "1";
        this.overlay.style.paddingBottom = "0";
      }
    } else {
      if (isActive) {
        this.submitButton.style.position = "relative";
        this.submitButton.style.zIndex = "10";
        this.submitButton.form.style.zIndex = "10";

      } else {
        setTimeout(() => {
          this.submitButton.style.zIndex = "1";
          this.submitButton.form.style.zIndex = "1";
        }, 200);
      }
    }
  }

  changeHandler(event) {
    const deliveryType = event.target.value;

    this.checkDeliveryType(deliveryType);
  }

  checkDeliveryType(deliveryType) {
    if (deliveryType === "address-delivery") {
      this.inputs.forEach((input) => {
        if (input.name === "name" || input.name === "phone" || input.name === "settlement") return;
        input.id = "address";
        input.placeholder = this.translations.inputPlaceholders.address;
      });
    } else {
      this.inputs.forEach((input) => {
        if (input.name === "name" || input.name === "phone" || input.name === "settlement") return;
        input.id = "warehouse";
        input.placeholder = this.translations.inputPlaceholders.warehouse;
      });
    }
  }

  controlButtonClickHandler(event) {
    if (event.target.closest(".control-button")) {
      this.toggleOverlay();
    }
  }

  inputHandler(event) {
    const value = event.target.value.trim();
    const inputId = event.target.id;

    if (value) {
      if (inputId === "settlement") {
        fetch(`${this.domain}/searchSettlements`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            providerId: this.providerId,
            cityName: value,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // Display suggestions (elastic search)
            this.displaySuggestions(inputId, data?.settlements);
          })
          .catch((error) => {
            console.error("Error:", error?.message || error);
          });
      } else if (inputId === "warehouse") {
        fetch(`${this.domain}/getWarehouses`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            findByString: value,
            providerId: this.providerId,
            cityRef: this.deliveryCity,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // Display suggestions (elastic search)
            this.displaySuggestions(inputId, data?.warehouses);
          })
          .catch((error) => {
            console.error("Error:", error?.message || error);
          });
      }
    } else {
      // Clear suggestions (elastic search) if input is empty
      if (inputId === "name" || inputId === "phone") {
        return;
      }

      this.clearSuggestions(inputId);
    }
  }

  displaySuggestions(inputId, data) {
    this.currentInputId = inputId;

    const suggestionsList = this.cart.querySelector(`#suggestions-${inputId}`);
    suggestionsList.innerHTML = "";

    const isSettlement = inputId === "settlement";

    data?.forEach((item) => {
      const li = document.createElement("li");
      li.textContent = isSettlement ? item.Present : item.Description;

      const suggestionClickHandler = (event) => {
        event.stopPropagation();
        this.cart.querySelector(`#${inputId}`).value = isSettlement
          ? item.Present
          : item.Description;
        this.clearSuggestions(inputId);

        if (isSettlement) {
          this.deliveryCity = item.DeliveryCity;
        }
      };

      li.addEventListener("click", suggestionClickHandler);

      suggestionsList.appendChild(li);
    });
    suggestionsList.style.display = "block";
  }

  clearSuggestions(inputId) {
    if (inputId === "address") return;
    const suggestionsList = this.cart.querySelector(`#suggestions-${inputId}`);
    suggestionsList.innerHTML = "";
    suggestionsList.style.display = "none";
  }

  documentClickHandler(event) {
    const isInput = event.target.classList.contains("overlay-form__input");
    const isSuggestion = event.target.classList.contains(
      "overlay-form__suggestions"
    );
    const isCurrentInput = event.target.id === this.currentInputId;

    if ((!isInput && !isSuggestion) || !isCurrentInput) {
      this.suggestionsLists?.forEach((list) => {
        list.style.display = "none";
      });
    }
  }

  getDeliveryInfo() {
    const deliveryType = this.cart.querySelector(
      'input[name="delivery-type"]:checked'
    ).value;
    const name = this.cart.querySelector("#name").value;
    const phone = this.cart.querySelector("#phone").value;
    const settlement = this.cart.querySelector("#settlement").value;
    const warehouse = this.cart.querySelector("#warehouse")?.value;
    const address = this.cart.querySelector("#address")?.value;

    return {
      deliveryType,
      name,
      phone,
      settlement,
      warehouse,
      address
    };
  }

  mouseoverHandler() {
    if (!this.isHovered) {
      this.changeSubmitButtonText(this.translations.chooseDeliveryMethod);
      this.isHovered = true;
      this.isOriginalText = false;
    }
  }

  mouseoutHandler() {
    if (!this.isOriginalText) {
      this.changeSubmitButtonText(this.originalSubmitButtonText);
      this.isHovered = false;
      this.isOriginalText = true;
    }
  }

  changeSubmitButtonText(text) {
    if (this.submitButton.innerHTML !== text) {
      const { deliveryType, name, phone, settlement, warehouse, address } =
        this.getDeliveryInfo();

      const animate = () => {
        this.submitButton.classList.add("change-text-animation");

        setTimeout(() => {
          this.submitButton.innerHTML = text;
        }, 125); // Animation duration (half of the CSS transition duration)

        setTimeout(() => {
          this.submitButton.classList.remove("change-text-animation");
        }, 250); // Animation duration (CSS transition duration)
      };

      if (!name || !phone) {
        animate();
        return;
      }

      if (deliveryType === "warehouse") {
        if (!settlement || !warehouse) {
          animate();
        }
      }

      if (deliveryType === "address-delivery") {
        if (!settlement || !address) {
          animate();
        }
      }
    }
  }

  async submitHandler(event) {
    event.preventDefault();

    const { deliveryType, name, phone, settlement, warehouse, address: deliveryAddress } =
      this.getDeliveryInfo();
    const isWarehouse = deliveryType === "warehouse";
    const isAddress = deliveryType === "address-delivery";

    if (!name || !phone || !settlement) {
      if (!this.overlay.classList.contains("active")) {
        this.toggleOverlay();
      }
      return;
    }

    if (isWarehouse) {
      if (!warehouse) {
        if (!this.overlay.classList.contains("active")) {
          this.toggleOverlay();
        }
        return;
      }
    }

    if (isAddress) {
      if (!deliveryAddress) {
        if (!this.overlay.classList.contains("active")) {
          this.toggleOverlay();
        }
        return;
      }
    }

    // Cart attributes
    const names = name?.split(" ");
    const firstName = names?.shift();
    const lastName = names?.join(" ");

    const attributes = isWarehouse
      ? {
          _provider: "Нова пошта",
          _delivery_method: "Відділення / Поштомат",
          _delivery_first_name: firstName,
          _delivery_last_name: lastName,
          _delivery_phone: phone,
          _delivery_city: settlement,
          _delivery_warehouse: warehouse,
          _delivery_warehouse_zip: "11111",
        }
      : {
          _provider: "",
          _delivery_method: "Адресна доставка",
          _delivery_first_name: firstName,
          _delivery_last_name: lastName,
          _delivery_phone: phone,
          _delivery_city: settlement,
          _delivery_address: deliveryAddress,
          _delivery_address_zip: "11111",
        };

    try {
      // Update cart attributes
      await fetch("/cart/update.js", {
        method: "POST",
        mode: "cors",
        credentials: "include",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes,
        }),
      });

      // Add delivery info to cart note
      const address = isWarehouse
        ? {
            countryCode: "UA",
            country: "Ukraine",
            address1: warehouse,
            zip: "11111",
            city: settlement,
            first_name: firstName,
            last_name: lastName,
            phone: phone,
          }
        : {
            countryCode: "UA",
            country: "Ukraine",
            address1: deliveryAddress,
            zip: "11111",
            city: settlement,
            first_name: firstName,
            last_name: lastName,
            phone: phone,
          };

      const response = await fetch("/cart.json");
      const data = await response.json();

      const pairs = [],
        path = data.items
          .map((item) => `${item.variant_id}:${item.quantity}`)
          .join(",");
      for (const key in attributes) {
        if (!attributes[key]) continue;
        const pair = `attributes[${key}]=${attributes[key]}`;
        pairs.push(pair);
      }
      for (const key in address) {
        const pair = `checkout[shipping_address][${key}]=${address[key]}`;
        pairs.push(pair);
      }

      // Redirect to checkout
      let params, url;
      const isDefaultLanguage = this.defaultLanguage === this.language;
      data.note && data.note != null
        ? ((params = pairs.join("&") + `&note=${data.note}`),
          (url = isDefaultLanguage
            ? `/cart/${path}?${params}`
            : `/${this.language}/cart/${path}?${params}`))
        : ((params = pairs.join("&")),
          (url = isDefaultLanguage
            ? `/cart/${path}?${params}`
            : `/${this.language}/cart/${path}?${params}`)),
        (window.location.href = url);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  defineTranslations() {
    if (this.language !== this.defaultLanguage) {
      this.translations = {
        shipping: "Choose a delivery method",
        chooseDeliveryMethod: "Choose a delivery method",
        options: {
            warehouse: "NovaPoshta",
            addressDelivery: "Address delivery"
        },
        inputPlaceholders: {
            name: "First and Last names",
            phone: "Phone number",
            settlement: "Select a settlement",
            warehouse: "Select branch / post office",
            address: "Street and house number"
        }
      };
    } else {
      // uk by default
      this.translations = {
        shipping: "Оберіть спосіб доставки",
        chooseDeliveryMethod: "Оберіть спосіб доставки",
        options: {
            warehouse: "Доставка Новою Поштою",
            addressDelivery: "Адресна доставка"
        },
        inputPlaceholders: {
            name: "Ім'я та прізвище",
            phone: "Номер телефону",
            settlement: "Оберіть населений пункт",
            warehouse: "Оберіть відділення або поштомат",
            address: "Вулиця та номер будинку"
        }
      };
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const cartControls = new CartControls();
});
